/* eslint-disable react/jsx-key */
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useState } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  allKmzs,
  allFetchedRoutes,
  selectedNavRouteAtom,
  comparisonRouteData,
} from '../../common/atom/atoms';
import { getPartnerColor } from './functions/get_color_for_partners.function';
import { Button, TextField } from '@mui/material';
import RouteAddEditeButtons from './route_add_edit_buttons.component';
import { openCompareRoutes } from '../../common/atom/atoms';
import { getCompareRoutesFromIds } from './functions/get_compare_routes_from_ids.function';
import { CustomCheckbox } from './custom_check_box_for_routes_selection.component';
import Swal from 'sweetalert2';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { handleRefresh } from '../../common/functions/refresh_map.function';
import VisibilityIcon from '@mui/icons-material/Visibility';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export const LockedRouteLeftBarComponent = (props) => {
  const { setCreateRoutePopup } = props;
  const allKmzData = useAtomValue(allKmzs);
  const setOpen = useSetAtom(openCompareRoutes);
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const allRoutes = useAtomValue(allFetchedRoutes);
  const [search, setSearch] = useState();
  const [selectedNavROute, setSelectedNavRoute] = useAtom(selectedNavRouteAtom);
  const [selectedRouteIds, setSelectedRouteIds] = useState([]);
  const [comparisonRouteDataValue, setComparisonRouteDataValue] = useAtom(comparisonRouteData);

  const handleSelectNav = (id) => {
    if (selectedNavROute === id) {
      setSelectedNavRoute(null);
    } else {
      setSelectedNavRoute(id);
    }
  };

  const handleCompare = () => {
    showBackdrop();
    if (selectedRouteIds.length === 0) {
      // alert("Please select at least one route to compare.");
      Swal.fire({
        text: `Select at least one route`,
        icon: 'info',
        width: '300px',
        height: '300',
        customClass: {
          popup: 'small-swal',
        },
      });
      hideBackdrop();
      return;
    }
    fetchComparedRoutes();
  };

  const fetchComparedRoutes = async () => {
    try {
      const ids = selectedRouteIds?.join(',');
      const ComparisonRoutesData = await getCompareRoutesFromIds(ids);
      setComparisonRouteDataValue(ComparisonRoutesData);
      console.log(ComparisonRoutesData);
      hideBackdrop();
      setOpen(true);
    } catch (error) {
      console.error('Error fetching routes:', error);
      hideBackdrop();
    }
  };
  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };
  const handleCheckboxChange = (routeId) => {
    setSelectedRouteIds(
      (prevSelected) =>
        prevSelected.includes(routeId)
          ? prevSelected.filter((id) => id !== routeId) // uncheck
          : [...prevSelected, routeId] // check
    );
  };

  const filteredRoutes = search
    ? allRoutes?.filter((route) => route.routeName.toLowerCase().includes(search.toLowerCase()))
    : allRoutes;

  return (
    <>
      <div className="alerts_header">
        <div className="alerts_title_icon">
          <div
            style={{
              alignSelf: 'stretch',
              marginTop: '8%',
              marginLeft: '12%',
              paddingBottom: 16,
              borderBottom: '1px #E5E9EB solid',
              justifyContent: 'space-between',
              alignItems: 'center',
              display: 'inline-flex',
            }}
          >
            <div
              style={{
                width: 340,
                height: 38,
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'inline-flex',
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Search Routes..."
                value={search}
                size="small"
                onChange={handleInputChange}
                InputProps={{
                  style: {
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    color: '#757F82',
                    maxWidth: 180,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#C4C4C4', // gray border
                    },
                    '&:hover fieldset': {
                      borderColor: '#A0A0A0', // darker gray on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#C4C4C4', // gray on focus
                    },
                  },
                }}
                title={search}
              />
              <Button
                variant="contained"
                onClick={() => handleCompare()}
                color="secondary"
                style={{ backgroundColor: '#BD1D23', color: '#FFF' }}
              >
                Compare
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="drawer-content" style={{ height: '76vh', marginTop: '10%' }}>
        <div className="alerts_list_main" style={{ height: '72vh', width: 380 }}>
          <PerfectScrollbar>
            <div style={{ padding: '5px', display: 'grid', gap: '20px' }}>
              <div
                style={{
                  width: 344,
                  boxSizing: 'border-box',
                  height: allKmzData?.length ? 724 : null,
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingBottom: 16,
                  background: 'white',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 24,
                  display: 'inline-flex',
                }}
              >
                {filteredRoutes?.length ? (
                  <div
                    style={{
                      alignSelf: 'stretch',
                      height: 418,
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 16,
                      display: 'flex',
                    }}
                  >
                    {filteredRoutes?.map((route) => {
                      const isSelected = selectedNavROute === route.id;
                      return (
                        <div
                          key={route.id}
                          onClick={() => handleSelectNav(route.id)}
                          style={{
                            alignSelf: 'stretch',
                            height: 134,
                            paddingTop: 8,
                            paddingBottom: 16,
                            paddingLeft: 8,
                            paddingRight: 8,
                            background: isSelected ? '#f5f5f5' : 'white',
                            boxShadow: isSelected
                              ? '0px 6px 10px rgba(0, 0, 0, 0.1)'
                              : '0px 4px 4px rgba(0, 0, 0, 0.04)',
                            borderBottom: isSelected
                              ? `2px solid ${getPartnerColor('jazz')}`
                              : '2px solid #f8e8e9',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 2,
                            display: 'flex',
                            cursor: 'pointer',
                            borderRadius: 8,
                            transition: 'all 0.3s ease-in-out',
                            transform: 'scale(1)',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.03)';
                            e.currentTarget.style.boxShadow = '0px 8px 16px rgba(0, 0, 0, 0.12)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = isSelected
                              ? '0px 6px 10px rgba(0, 0, 0, 0.1)'
                              : '0px 4px 4px rgba(0, 0, 0, 0.04)';
                          }}
                        >
                          <div
                            style={{
                              alignSelf: 'stretch',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-start',
                              gap: 8,
                              display: 'inline-flex',
                            }}
                          >
                            <div
                              data-svg-wrapper
                              style={{ position: 'relative' }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <CustomCheckbox
                                route={route}
                                selectedRouteIds={selectedRouteIds}
                                handleCheckboxChange={handleCheckboxChange}
                              />
                            </div>

                            <div
                              style={{
                                flex: '1 1 0',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 2,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  alignSelf: 'stretch',
                                  height: 20,
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  display: 'inline-flex',
                                }}
                              >
                                <div
                                  style={{
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    gap: 8,
                                    display: 'flex',
                                  }}
                                >
                                  <div
                                    style={{
                                      color: '#090C0D',
                                      fontSize: 12,
                                      fontFamily: 'Poppins',
                                      fontWeight: '500',
                                      wordWrap: 'break-word',
                                    }}
                                  >
                                    Name:
                                  </div>
                                  <div
                                    style={{
                                      color: '#757F82',
                                      fontSize: 12,
                                      fontFamily: 'Poppins',
                                      fontWeight: 500,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: 120,
                                    }}
                                    title={route.routeName}
                                  >
                                    {route.routeName}
                                  </div>

                                  {isSelected && (
                                    <div
                                      style={{
                                        marginLeft: 4,
                                        color: '#757F82',
                                        fontSize: 14,
                                      }}
                                      title="Visible on map"
                                    >
                                      <VisibilityIcon
                                        sx={{
                                          fontSize: 16,
                                          color: '#757F82',
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>

                                <div
                                  data-svg-wrapper
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <RouteAddEditeButtons
                                    route={route}
                                    setCreateRoutePopup={setCreateRoutePopup}
                                  />
                                </div>
                              </div>

                              <div
                                style={{
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 8,
                                  display: 'inline-flex',
                                }}
                              >
                                <div
                                  style={{
                                    color: '#090C0D',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  Length:
                                </div>
                                <div
                                  style={{
                                    color: '#757F82',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: 120,
                                  }}
                                  title={route.length}
                                >
                                  {Math.round(route.length).toLocaleString()} Mtr
                                </div>
                              </div>

                              <div
                                style={{
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 8,
                                  display: 'inline-flex',
                                }}
                              >
                                <div
                                  style={{
                                    color: '#090C0D',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  Cost:
                                </div>
                                <div
                                  style={{
                                    color: '#757F82',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: 170,
                                  }}
                                  title={route.totalCost}
                                >
                                  {Math.round(route.totalCost).toLocaleString()} (Pkr)
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div>No Data Available</div>
                )}
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
};
